import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './MissingRequiredSections.module.scss';

type Props = {
  sections: { code: string; title: string }[];
  className?: string;
  // Shows the section in the document; without it the titles are text.
  onSelect?: (code: string) => void;
};

// Required is a review requirement: the clinician sees which required
// sections have no answer and may still finish or save without them.
export const MissingRequiredSections: FC<Props> = ({
  sections,
  className,
  onSelect,
}) => {
  const { formatList, formatMessage } = useIntl();
  const titles = sections.map(({ code, title }, index) =>
    onSelect ? (
      <button
        key={`${code}/${index}`}
        type="button"
        className={styles.link}
        onClick={() => onSelect(code)}
      >
        {title}
      </button>
    ) : (
      formatMessage(
        {
          id: 'workspace.template.quotedTitle',
          defaultMessage: '“{title}”',
        },
        { title },
      )
    ),
  );

  return (
    <p
      role="status"
      className={cn('p2', styles.warning, className)}
      data-component="workspace-missing-required"
    >
      {onSelect ? (
        <FormattedMessage
          id="workspace.template.missingRequired"
          defaultMessage="Required sections without an answer: {sections}. Check them before you finish; leaving them empty is allowed."
          values={{ sections: formatList(titles, { type: 'conjunction' }) }}
        />
      ) : (
        <FormattedMessage
          id="workspace.saveToRecordMissingRequired"
          defaultMessage="Required sections without an answer: {sections}. You can still save to the record."
          values={{ sections: formatList(titles, { type: 'conjunction' }) }}
        />
      )}
    </p>
  );
};
